import { SvgIconPropsColorOverrides, useTheme } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

export type ColorType =
  | OverridableStringUnion<
      | "success"
      | "warning"
      | "error"
      | "info"
      | "inherit"
      | "action"
      | "disabled"
      | "primary"
      | "secondary"
      | "accent"
      | "light"
      | "dark"
      | "lightHover"
      | "darkHover"
      | "accentHover",
      SvgIconPropsColorOverrides
    >
  | undefined;

export const useGetSvgIconFill = (
  color: ColorType | undefined,
  defaultColor?: ColorType
): string => {
  const theme = useTheme();

  switch (color) {
    case "dark":
      return theme.igIconColors.dark;
    case "success":
      return theme.igIconColors.success;
    case "warning":
      return theme.igIconColors.warning;
    case "error":
      return theme.igIconColors.error;
    case "accent":
      return theme.igIconColors.accent;
    case "info":
      return theme.igIconColors.info;
    case "accentHover":
      return theme.igIconColors.accentHover;
    case "darkHover":
      return theme.igIconColors.darkHover;
    case "lightHover":
      return theme.igIconColors.lightHover;

    default:
      return theme.igIconColors[defaultColor || "light"];
  }
};
